import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type ConfigModel from 'garaje/models/config';

class Integration extends Model {
  @belongsTo('config', { async: true, inverse: 'integrations' })
  declare config: AsyncBelongsTo<ConfigModel>;

  @attr('string')
  declare type: string;

  @attr('string')
  declare folderId: string;

  @attr('string')
  declare folderName: string;
}

export default Integration;
